// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2RyR4","title":"styles_title__24yeB"};